import { render, staticRenderFns } from "./LotDetails.vue?vue&type=template&id=2a9c2144&scoped=true&"
import script from "./LotDetails.vue?vue&type=script&lang=js&"
export * from "./LotDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a9c2144",
  null
  
)

export default component.exports